(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('FeedbackController', FeedbackController);

    FeedbackController.$inject = ['Principal','OTPService','$state','vcRecaptchaService'];

    function FeedbackController (Principal,OTPService,$state,vcRecaptchaService) {
        var vm = this;
        vm.publicKey = "6LfItR0UAAAAAI7yY9TTAp2mC40kVepEHrK77fpF";
        
        var isAuthenticated=Principal.isAuthenticated();
        vm.cancel=cancel;
        vm.feedbacksubmit=feedbacksub;
        vm.feedback={};
        vm.success=false;
        vm.setRecaptchaId=setRecaptchaId;
        vm.recaptchaId=null;
        vm.captcha=true;
        
        //$timeout(function (){angular.element('#exampleInputUsername').focus();});
        function setRecaptchaId(widgetId) {
         vm.recaptchaId = widgetId;
         if(vm.recaptchaId>=0){
         	vm.captcha=false;
         }else{
         	vm.captcha=true;
         }
     };
        
        
        function cancel(){
        if(isAuthenticated){
        $state.go('home');	
        }else{
        	$state.go('login');
        }
        }
        
        function feedbacksub(){
        	
        	OTPService.sendfeedback(vm.feedback).then(function(response)
        			{
        		vm.oopsmes=false;
        		vm.success=true;
        			})["catch"](function(response){
        				vm.success=false;
        				vm.oopsmes=true;
        			})
        			
        			var response = vcRecaptchaService.getResponse(vm.recaptchaId);
        	//alert(response);
        	
        	 if(response === ""){
        		 vm.captcha=false;
                // alert("Please resolve the captcha and submit!")
             }else{
            	 vm.captcha=true;
             }
        		if(vm.captcha && $scope.passerror && $scope.emailformaterror){
                   	if(vm.check){
                  	//vm.valid=true;
                	var registereddata=vm.registerAccount;
                  	$state.go('smsotpverification',{registereddata:registereddata});
                   	}
        }
        		}
    }
})();
